<template>
  <div class="faq-section">
    <h2>Frequently Asked Questions</h2>
    <div class="faq-container">
      <div
        v-for="(item, index) in faqItems"
        :key="index"
        class="faq-item"
        data-aos="fade-up"
        data-aos-duration="800"
        :data-aos-delay="index > 0 ? index * 100 + 200 : 0"
        data-aos-once="true"
      >
        <div class="faq-question">{{ item.question }}</div>
        <div class="faq-answer">{{ item.answer }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $Aos } = useNuxtApp();
const faqItems = ref([
  {
    question: "Do I need special equipment to create 360° tours?",
    answer:
      "No, that's the beauty of Travvir! You only need a smartphone to capture and create professional-quality 360° views. Our AI technology handles the rest.",
  },
  {
    question: "How do I embed tours into my client's website?",
    answer:
      "We provide simple embed codes that work with virtually any website platform. Just copy and paste the code into your client's site to display the interactive tour.",
  },
  {
    question: "What industries can benefit from Travvir partnerships?",
    answer:
      "Our partners span across real estate, hospitality, interior design, architecture, construction, event venues, retail, museums, and many other industries where immersive visual experiences add value.",
  },
]);

onMounted(() => {
  $Aos.init();
});
</script>

<style lang="scss" scoped>
.faq-section {
  padding: 6rem 2rem 8rem;

  @include respond-below(sm) {
    padding: 4rem 1rem 6rem;
  }

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 39px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    font-family: "Manrope", sans-serif;
    text-align: center;
    margin-bottom: 2rem;

    @include respond-below(sm) {
      font-size: 28px;
    }
  }

  .faq-container {
    max-width: 800px;
    margin: 0 auto;

    .faq-item {
      margin-bottom: 1.5rem;
      padding: 1.5rem;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      transition: background-color 0.2s ease;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.08);
      }

      .faq-question {
        font-weight: 500;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 0.8rem;
      }

      .faq-answer {
        color: rgba(255, 255, 255, 0.4);
        line-height: 1.6;
        font-size: 16px;
      }
    }
  }
}
</style>
